import React from 'react';
import { PlusIcon } from '@heroicons/react/24/outline';

interface ReusableButtonProps {
  onClick?: () => void;
  icon?: React.ReactNode;
  label: string;
  className?: string;
  disabled?: boolean;
}

const ReusableButton: React.FC<ReusableButtonProps> = ({
  onClick,
  icon = <PlusIcon className="size-5" aria-hidden="true" />,
  label,
  className = '',
  disabled = false,
}) => {
  return (
    <button
      onClick={onClick}
      className={`inline-flex items-center gap-1 rounded-md bg-gray-600 py-2 px-3 text-sm/6 font-semibold text-white focus:outline-none hover:bg-gray-500 mr-3 transition-all ${className} ${
        disabled ? 'opacity-50 cursor-not-allowed' : ''
      }`}
      disabled={disabled}
    >
      {icon}
      {label}
    </button>
  );
};

export default ReusableButton;
